import type { ServerResponse } from "http";
import { NextHandler } from "next-connect";

import { setCookie } from "helpers/cookie";
import transcodeLocale from "helpers/transcodeLocale";
import { getServerSideUserData } from "helpers/userData";

import type { CustomRequest } from "types/request";

const IS_DEV = process.env.NODE_ENV === "development";
export const DOMAINS = JSON.parse(`${process.env.DOMAINS}`) as Record<
  string,
  string
>;

const authorizationMiddleware =
  (locale: string) =>
  async (req: CustomRequest, res: ServerResponse, next: NextHandler) => {
    const authorizationToken = req.cookies["auth._token.local"];
    const parsedUrl = new URL(req.url as string, `http://${req.headers.host}`);

    // The user is not logged in. We don't need to validate the authorization token
    if (!authorizationToken) {
      return next();
    }

    const currentLocale = transcodeLocale(locale, "iso3166", "icu");

    const baseUrl = DOMAINS[currentLocale ?? "es-AR"];
    const nextUrl = encodeURIComponent(parsedUrl.href);
    const loginUrl = `https://${baseUrl}/auth/login?nextUrl?=${nextUrl}`;

    const userMe = await getServerSideUserData(authorizationToken, locale);

    if (!userMe) {
      setCookie(res, "auth._token.local", "", { maxAge: 0 });
      res.statusCode = 302;
      res.setHeader("Location", loginUrl);

      // If we are in development, we redirect to the error page so that the
      // Set-Cookie header can be set in the context of the current domain (localhost)
      if (IS_DEV) {
        res.setHeader("Location", "http://localhost:3000/_error");
      }
    } else {
      req.userData = userMe;
      req.authorizationToken = authorizationToken;
    }

    return next();
  };

export default authorizationMiddleware;
